export const getUppercaseExtName = (extension: string): string => {
  return extension
    .split('-')
    .map(str => `${str.slice(0, 1).toUpperCase()}${str.slice(1)}`)
    .join('')
}
